import React from 'react';
import { TranslateProvider, TranslateScope } from '@pegasus/translation';
import PermissionDialog from './PermissionDialog';
import ReenableDialog from './ReenableDialog';
const devNullFn = () => { };
export function PushNotificationsDialogs({ dialogControls, translations, firstName, data, onRegister, onTrack = devNullFn, }) {
    return (React.createElement(TranslateProvider, { translations: translations },
        React.createElement(TranslateScope, null,
            React.createElement(PermissionDialog, { isShown: dialogControls.permissionDialogShow, data: data, onClose: dialogControls.onPermissionDialogClose, onRegister: onRegister, firstName: firstName, onTrack: onTrack }),
            React.createElement(ReenableDialog, { isShown: dialogControls.reEnableDialogShow, data: data, onClose: dialogControls.onReenableDialogClose, onTrack: onTrack }))));
}
//# sourceMappingURL=PushNotificationsDialogs.js.map